import { Box, Stack, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, IconButton, Autocomplete, InputAdornment, Modal, FormControlLabel, Switch, Tooltip, } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Colors } from "../../../../Styles/Colors";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton } from "../../../../Components/Common Components/CommonComponents";
import { PhotoCamera } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ImagePaths } from "../../../../Utility/ImagePaths";
import Webcam from "react-webcam";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CancelIcon from '@mui/icons-material/Cancel';
import Loader from "../../../../Components/Loader";
import CommonValidation from "../../../../Components/CommonFunctions/CommonValidation";
import { passwordValidations } from "../../../../Components/CommonFunctions/CommonFunctions";


const GlobalUserAccess = () => {
    const [state, setState] = useState({
        user_access_data: [],
        is_loader: false,
        selected_ids: [],
        checkbox_list: [],
        page: 0,
        pageSize: 10,
        // toast msg state
        isErrorMsg: false,
        isErrorMsgText: "",
        successMsg: false,
        successMsgText: "",
        usersList: [],
        UserIsInActive: false,
    });

    // Modal state
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState("add");
    const [editId, setEditId] = useState(null);
    // Profile picture state
    const [tempProfilePic, setTempProfilePic] = useState(null);
    const [profilePic, setProfilePic] = useState(null);
    const [picUploadopen, setPicUploadopen] = useState(false);
    const [webCamOpen, setWebCamOpen] = useState(false);
    const [profilePreview, setProfilePreview] = useState("");
    // Add state for user dropdown
    const [selectedOldUser, setSelectedOldUser] = useState('');
    const [roleList, setRoleList] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const webPicRef = useRef(null);

    // Form state
    const [formData, setFormData] = useState({
        first_name_key: "",
        last_name_key: "",
        mobile_number: "",
        email: "",
        role_id: "",
        registration_no: "",
        notes: "",
        username_key: "",
        password_key: "",
        isOldUser: false,
        UserIsInActive: false
    });

    // Fetch data
    useEffect(() => {
        getUserAccessList();
        getRoles()
    }, []);

    // State helpers
    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const successMessage = (message) => {
        updateState({ successMsg: true, successMsgText: message });
    };

    const errorMessage = (message) => {
        updateState({ isErrorMsg: true, isErrorMsgText: message });
    };

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: "",
            successMsg: false,
            successMsgText: "",
        });
    };


    // Modal handlers
    const handleOpenAdd = () => {
        setMode("add");
        setEditId(null);
        setFormData({
            first_name_key: "",
            last_name_key: "",
            mobile_number: "",
            email: "",
            role_id: "",
            registration_no: "",
            notes: "",
            username_key: "",
            password_key: "",
            isOldUser: false
        });
        setProfilePic(null);
        setOpen(true);
    };

    const handleOpenEdit = (row) => {
        setMode("edit");
        setEditId(row.id);
        setFormData({
            first_name_key: row.first_name || "",
            last_name_key: row.last_name || "",
            mobile_number: row.mobile_number || "",
            email: row.email || "",
            role_id: roleList?.find((item) => (item?.id === row?.role_master_id)) || "",
            registration_no: row.register_no || "",
            notes: row.notes || "",
            username_key: row.username || "",
            password_key: "",
            UserIsInActive: row.is_deactivated,
            isOldUser: false
        });
        setProfilePic(row.user_image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        const { first_name_key, email, mobile_number, role_id, password_key, username_key } = formData;
        var passWord = passwordValidations(password_key)
        const validations = [
            { valid: first_name_key?.trim(), msg: "First Name is required" },
            { valid: email?.trim(), msg: "Email is required" },
            { valid: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email), msg: "Invalid Email format", when: !!email?.trim() },
            { valid: mobile_number?.trim(), msg: "Mobile Number is required" },
            { valid: /^[0-9]{10}$/.test(mobile_number), msg: "Mobile Number must be 10 digits", when: !!mobile_number?.trim() },
            { valid: role_id, msg: "Role is required" },
            { valid: username_key?.trim(), msg: "User Name is required" },
        ];
        for (const { valid, msg, when = true } of validations) {
            if (!valid && when) {
                errorMessage(msg);
                return false;
            }
        }
        if (mode === "add") {
            if (!password_key?.trim()) {
                errorMessage("Password is required for new users");
                return false;
            }
        }
        if (password_key && passWord) {
            errorMessage(passWord)
            return false
        }
        return true;
    };

    const getUserAccessList = () => {
        try {
            updateState({ is_loader: true });
            RestAPIService.getAll(Serviceurls.GLB_USER_ACCESS)
                .then((response) => {
                    if (response?.data?.status === "success") {
                        const Data = response.data.data || [];
                        updateState({
                            user_access_data: Data?.map((element, index) => ({
                                ...element,
                                sno: index + 1,
                            })),
                            is_loader: false,
                        });
                    }
                })
                .catch((e) => {
                    updateState({ is_loader: false });
                    errorMessage(e?.response?.data?.message || e?.message);
                });
        } catch (e) {
            updateState({ is_loader: false });
            errorMessage(e.message);
        }
    };

    const getRoles = () => {
        try {
            RestAPIService.getAll(Serviceurls.GLB_ROLE_MASTER)
                .then((response) => {
                    if (response?.data?.status === "success") {
                        setRoleList(response.data.data || [])
                    }
                })
                .catch((e) => {
                    console.error("Error fetching users:", e);
                });
        } catch (e) {
            console.error("Error fetching users:", e);
        }
    };

    const dataURItoBlob = async (dataURI) => {
        if (!dataURI?.startsWith("data:")) {
            const response = await fetch(dataURI);
            const blob = await response?.blob();
            return blob;
        } else {
            const byteString = atob(dataURI.split(",")[1]);
            const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
            const ab = new ArrayBuffer(byteString?.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString?.length; i++) {
                ia[i] = byteString?.charCodeAt(i);
            }
            return new Blob([ab], { type: mimeString });
        }
    };

    // API calls
    const handleSubmit = async () => {
        if (!validateForm()) return;
        try {
            updateState({ is_loader: true });
            let data = new FormData();
            const userImage = (profilePic === null || profilePic === "" || profilePic?.includes("https://")) ? "None" : await dataURItoBlob(profilePic);
            data.append("first_name", formData.first_name_key);
            data.append("last_name", formData.last_name_key);
            data.append("mobile_number", formData.mobile_number);
            data.append("email", formData.email);
            data.append("role_master_id", (formData.role_id?.id || null));
            data.append("register_no", formData.registration_no);
            data.append("notes", formData.notes);
            data.append("username", formData.username_key);
            data.append("password", formData.password_key);
            data.append("user_image", userImage);
            data.append("is_deactivated", formData?.UserIsInActive);

            RestAPIService.create(data, Serviceurls.GLB_USER_ACCESS)
                .then((response) => {
                    if (response?.data?.status === "success") {
                        getUserAccessList();
                        successMessage(response?.data?.message);
                        handleClose();
                        updateState({ is_loader: false });
                    }
                })
                .catch((e) => {
                    errorMessage(e?.response?.data?.message || e?.message);
                    updateState({ is_loader: false });
                });
        } catch (e) {
            errorMessage(e.message);
            updateState({ is_loader: false });
        }
    };

    const handleUpdate = async () => {
        if (!validateForm()) return;
        try {
            updateState({ is_loader: true });
            let data = new FormData();
            const userImage = (profilePic === null || profilePic === "" || profilePic?.includes("https://")) ? "None" : await dataURItoBlob(profilePic);
            data.append("id", editId);
            data.append("first_name", formData.first_name_key);
            data.append("last_name", formData.last_name_key);
            data.append("mobile_number", formData.mobile_number);
            data.append("email", formData.email);
            data.append("role_master_id", formData.role_id?.id || null);
            data.append("username", formData.username_key);
            data.append("register_no", formData.registration_no);
            data.append("notes", formData.notes);
            data.append("user_image", userImage);
            data.append("is_deactivated", formData?.UserIsInActive);
            if (formData.password_key) {
                data.append("password", formData.password_key);
            }

            RestAPIService.create(data, `${Serviceurls.GLB_USER_ACCESS}`)
                .then((response) => {
                    if (response?.data?.status === "success") {
                        getUserAccessList();
                        successMessage(response?.data?.message);
                        handleClose();
                        updateState({ is_loader: false });
                    }
                })
                .catch((e) => {
                    errorMessage(e?.response?.data?.message || e?.message);
                    updateState({ is_loader: false });
                });
        } catch (e) {
            errorMessage(e.message);
            updateState({ is_loader: false });
        }
    };

    const OpenWebCamPopUP = () => {
        try {
            return (
                <Box>
                    <Modal open={true}>
                        <Box className="eMed_WebCamPop_Main">
                            <Box component={'div'} className="eMed_WebCam_Header">
                                <Typography variant='h6'>{"Patient Profile "}</Typography>
                                <Button onClick={() => {
                                    setTempProfilePic(profilePic)
                                    setWebCamOpen(false)
                                }} >
                                    <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                                </Button>
                            </Box>
                            <Box component={'div'}>
                                {tempProfilePic === null ?
                                    <Webcam
                                        className='eMed_WebCam_Div'
                                        audio={false}
                                        mirrored={true}
                                        ref={webPicRef}
                                        screenshotFormat="image/jpeg"
                                    /> :
                                    <img className='eMed_WebCam_Img_Div' src={tempProfilePic} />}
                            </Box>
                            <Box component={'div'} className="eMed_WebCam_Btn_div" width={"70%"} >
                                <Button disabled={tempProfilePic !== null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { setTempProfilePic(webPicRef.current.getScreenshot()) }}>Capture</Button>
                                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { setTempProfilePic(null) }}>Retake</Button>
                                <Button disabled={tempProfilePic === null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => {
                                    setProfilePic(tempProfilePic)
                                    setWebCamOpen(false)
                                }}>Set Profile</Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            );
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const TruncateTooltip = ({ text, max = 15, fontSize = "0.9vw" }) => {
        if (!text) return "-";

        const display = text.length > max ? text.slice(0, max) + "..." : text;

        return text.length > max ? (
            <Tooltip placement="top" title={text}>
                <Typography fontSize={fontSize} noWrap>
                    {display}
                </Typography>
            </Tooltip>
        ) : (
            <Typography fontSize={fontSize} noWrap>
                {text}
            </Typography>
        );
    };

    // Table columns
    const columns = [
        {
            field: "profile_pic",
            headerName: "Profile",
            flex: 0.2,
            renderCell: ({ row }) => (
                <div className="eMed_Com_Patient_Avatar">
                    <img className="eMed_Com_Patient_AvaIcon" src={row?.user_image ? row?.user_image : ImagePaths.Male.default} alt={'Avatar'} />
                </div>
            ),
        },
        {
            field: "first_name",
            headerName: "User Information",
            flex: 0.4,
            renderCell: ({ row }) => (
                <Box component="div">
                    <TruncateTooltip text={row?.first_name} max={30} />
                    <TruncateTooltip text={row?.mobile_number} max={15} fontSize={"0.8vw"} />
                </Box>
            ),
            valueGetter: (params) => {
                const Name = params.row?.first_name || "";
                const Mobile = params.row?.mobile_number || "";
                return `${Name} ${Mobile}`;
            }
        },
        {
            field: "username",
            headerName: "Username",
            flex: 0.3,
            renderCell: ({ row }) => (
                <TruncateTooltip text={row?.username} max={22} />
            ),
        },
        {
            field: "register_no",
            headerName: "Reg No",
            flex: 0.2,
            renderCell: ({ row }) => (
                <TruncateTooltip text={row?.register_no} max={18} />
            ),
        },
        {
            field: "role_name",
            headerName: "Role",
            flex: 0.2,
            renderCell: ({ row }) => (
                <TruncateTooltip text={row?.role_name} max={18} />
            ),
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.2,
            renderCell: ({ row }) => (
                <Typography fontSize={"0.9vw"} color={!row?.is_deactivated ? "green" : "red"}>
                    {!row?.is_deactivated ? "Active" : "Inactive"}
                </Typography>
            ),
            valueGetter: (params) => {
                const status = params?.row?.is_deactivated ? "Inactive" : "Active";
                if (status === "Inactive") return "Inactive";
                if (status === "Active") return "Active";
                return status || "-";
            },
        },
        {
            field: "action",
            headerName: "Action",
            flex: 0.2,
            renderCell: ({ row }) => (
                <Stack direction="row" alignItems="center" spacing={2}>
                    <CommonEditButton
                        size="1.5vw"
                        disable={state?.selected_ids?.length > 0}
                        onClick={() => handleOpenEdit(row)}
                    />
                </Stack>
            ),
        },
    ];

    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const UploadImage = (e, key) => {
        var files = e.target.files[0]
        getBase64(files, (result) => {
            setProfilePic(result)
            setPicUploadopen(false)
        });
    }

    return (
        <Box component={"div"} sx={{ height: "79.5vh", width: "94vw", backgroundColor: Colors.Background, padding: ".5vw" }}>

            <Box component={"div"}
                sx={{
                    height: "74vh",
                    width: "93vw",
                    marginTop: ".5vw",
                    backgroundColor: "white",
                }}
            >
                <DataGrid
                    rows={state.user_access_data}
                    columns={columns}
                    getRowId={(row) => row["sno"]}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: "",
                    }}
                    components={{
                        Toolbar: () => (
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} height={"3vw"} p={2} >
                                <GridToolbarQuickFilter
                                    sx={{ flexWrap: "nowrap" }}
                                    isInactive={true}
                                />
                                <Button style={{ marginTop: "0.75vw" }} size="small" variant="contained" onClick={handleOpenAdd}>
                                    Add
                                </Button>
                            </Box>
                        ),
                        NoRowsOverlay: () => (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                {"No Records To Be Shown"}
                            </Box>
                        ),
                    }}
                    onPageChange={(newPage) => {
                        updateState({ page: newPage });
                    }}
                    onPageSizeChange={(newPageSize) => {
                        updateState({ pageSize: newPageSize });
                    }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={state.is_loader}
                />
            </Box>

            {/* Toast messages */}
            {state.isErrorMsg && (
                <ToastMsg
                    severity={"error"}
                    msg={state.isErrorMsgText}
                    msgPop={msgClose}
                />
            )}
            {state.successMsg && (
                <ToastMsg
                    severity={"success"}
                    msg={state.successMsgText}
                    msgPop={msgClose}
                />
            )}

            {/* Add/Edit User Modal */}
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <Box sx={{ display: 'flex', paddingRight: 2 }}>
                    <DialogTitle>User Details</DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: "flex-end", alignItems: "center", gap: 2, flexGrow: 1 }}>
                        <Box>
                            <FormControlLabel control={<Switch color="error" size='small' checked={formData?.UserIsInActive} onChange={(e) => {
                                setFormData({ ...formData, UserIsInActive: e.target.checked });
                            }} />} label="In-Active User" />
                        </Box>
                        <IconButton onClick={handleClose} color="primary">
                            X
                        </IconButton>
                    </Box>
                </Box>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        {/* Profile Picture Upload */}
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '1vw', alignItems: "center" }}>
                                <img src={profilePic ? profilePic : ImagePaths.Male.default} onClick={() => setPicUploadopen(true)} alt='profile'
                                    className={profilePic ? 'eMed_new_img_res_ui' : 'eMed_new_profile_ui'} />
                                {/* {picUploadopen ? null :
                                    <img
                                        src={ImagePaths.AddUserButton.default}
                                        alt='add'
                                        className='eMed_Useradd_btn_ui'
                                        onClick={() => setPicUploadopen(true)}
                                    />} */}
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', visibility: picUploadopen ? "visible" : "hidden" }}>
                                <Box component={'div'}>
                                    <IconButton color="primary" onClick={() => setWebCamOpen(true)}>
                                        <PhotoCamera />
                                    </IconButton>
                                    <IconButton color="primary" aria-label="upload picture" component="label">
                                        <input hidden accept="image/*" type="file" onChange={(e) => { UploadImage(e, "profile") }} />
                                        <UploadFileIcon />
                                    </IconButton>
                                    <IconButton color="primary"
                                        onClick={() => setPicUploadopen(false)}>
                                        <CancelIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                Upload Profile Picture
                            </Typography>
                        </Grid>
                        {/* Form Fields */}
                        <Grid item xs={6}>
                            <TextField
                                label="First Name *"
                                name="first_name_key"
                                size="small"
                                fullWidth
                                inputProps={{ maxLength: 50 }}
                                value={formData.first_name_key}
                                onChange={(e) => {
                                    if (CommonValidation.alphabetOnly(e.target.value) || e.target.value === '') {
                                        handleChange(e)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Last Name"
                                name="last_name_key"
                                size="small"
                                fullWidth
                                inputProps={{ maxLength: 50 }}
                                value={formData.last_name_key}
                                onChange={(e) => {
                                    if (CommonValidation.alphabetOnly(e.target.value) || e.target.value === '') {
                                        handleChange(e)
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Mobile Number *"
                                name="mobile_number"
                                size="small"
                                inputProps={{ maxLength: 10 }}
                                fullWidth
                                value={formData.mobile_number}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) {
                                        setFormData({ ...formData, mobile_number: value });
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Mail ID *"
                                size="small"
                                name="email"
                                inputProps={{ maxLength: 50 }}
                                fullWidth
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                size="small"
                                options={roleList}
                                value={formData?.role_id || null}
                                getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt?.role_name || "")}
                                onChange={(event, newValue) => {
                                    setFormData({ ...formData, role_id: newValue });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Role *" sx={{ width: "100%" }} />
                                )}
                                sx={{
                                    "& .MuiAutocomplete-option": {
                                        whiteSpace: "normal", // ✅ allows wrapping
                                        wordBreak: "break-word", // ✅ breaks long words
                                        lineHeight: "1.3",
                                        maxWidth: "100%", // keeps inside the dropdown
                                    },
                                }}
                                slotProps={{
                                    paper: {
                                        sx: {
                                            maxWidth: "30vw", // ✅ optional: control dropdown width
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Reg No"
                                name="registration_no"
                                size="small"
                                inputProps={{ maxLength: 50 }}
                                fullWidth
                                value={formData.registration_no}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Notes"
                                size="small"
                                name="notes"
                                inputProps={{ maxLength: 50 }}
                                fullWidth
                                maxRows={2}
                                multiline
                                value={formData.notes}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Username *"
                                size="small"
                                name="username_key"
                                inputProps={{ maxLength: 50 }}
                                autoComplete="new-password"
                                fullWidth
                                value={formData.username_key}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label={`Password ${mode === "add" ? "*" : ""}`}
                                name="password_key"
                                size="small"
                                autoComplete="new-password"
                                type={showPassword ? 'text' : 'password'}
                                fullWidth
                                inputProps={{ maxLength: 50 }}
                                value={formData.password_key}
                                onChange={(e) => {
                                    if (CommonValidation.PasswordInput(e.target.value) || e.target.value === '') {
                                        handleChange(e)
                                    }
                                }}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment>
                                            <IconButton onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="small" disabled={state.is_loader} sx={{ textTransform: 'capitalize' }} onClick={handleClose} variant='outlined'>
                        Cancel
                    </Button>
                    <Button
                        size="small" sx={{ textTransform: 'capitalize' }}
                        onClick={mode === "add" ? handleSubmit : handleUpdate}
                        color="primary"
                        disabled={state.is_loader}
                        variant="contained"
                    >
                        {mode === "add" ? "Add" : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Loader loaderOpen={state.is_loader} />
            {webCamOpen ? OpenWebCamPopUP() : null}
        </Box>
    );
};

export default GlobalUserAccess;
